import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=2a5b6e8a&scoped=true&"
import script from "./Certificate.vue?vue&type=script&lang=js&"
export * from "./Certificate.vue?vue&type=script&lang=js&"
import style0 from "./Certificate.vue?vue&type=style&index=0&id=2a5b6e8a&scoped=true&lang=css&"
import style1 from "./Certificate.vue?vue&type=style&index=1&id=2a5b6e8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5b6e8a",
  null
  
)

export default component.exports